import React, { useState, useRef, useEffect } from 'react';
import './FilterDropdown.css';

export default function FilterDropdown({ value, onChange, options, disabled = false, placeholder = 'Select' }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  
  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
  };

  return (
    <div className="filter-dropdown" ref={dropdownRef}>
      <button
        ref={buttonRef}
        className="filter-dropdown-btn"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        disabled={disabled}
      >
        <span>{options.find(opt => opt.value === value)?.label || placeholder}</span>
        <svg className="dropdown-icon" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
          <path d="M4.5 6.5l3.5 3.5 3.5-3.5" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {isOpen && (
        <div className="filter-dropdown-menu">
          {options.map((option) => (
            <button
              key={option.value}
              className={`filter-dropdown-item ${value === option.value ? 'active' : ''}`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
